import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import AnglofoneLanding from './components/LandingPage';
import ThankYouPage from './components/ThankYou';

const theme = createTheme({
  palette: {
    primary: {
      main: '#C81E3A', // Match your brand red
      light: '#E84A6A',
      dark: '#8E1229'
    },
    secondary: {
      main: '#D9A441' // Match your brand gold
    },
    background: {
      default: '#FBEFE7',
      paper: '#FFFFFF'
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h3: {
      fontWeight: 700
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16
        }
      }
    }
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<AnglofoneLanding />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;